// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-resource-view{position:relative;box-sizing:border-box}.activity-resource-view .ivu-tabs-content{width:calc(100% - 20px);height:calc(100% - 66px);position:absolute}.activity-resource-view .ivu-tabs-content .res-header{box-shadow:0 2px 5px 0 #eee;height:40px;line-height:40px}.activity-resource-view .ivu-tabs-content .res-list{max-height:calc(100% - 100px);overflow-y:scroll;overflow-x:hidden;border:1px solid #eee}", ""]);
// Exports
module.exports = exports;
